import { Observable } from 'rxjs';

export abstract class AuthService {
    abstract baseUrl: string;

    abstract loginToExternalProvider(providerName: string): Observable<string>;
}
